import { useParams } from 'react-router-dom';
import { useWorkspaces } from '../providers/WorkspaceProvider';
import { NovahHub } from '../components/NovahHub';
import { PageSkeleton } from '../components/PageSkeleton';

export function WorkspaceHubPage() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { workspaces } = useWorkspaces();

  const workspace = workspaces.find((w) => w.id === workspaceId);

  if (!workspace) {
    return <PageSkeleton />;
  }

  return (
    <NovahHub
      workspaceId={workspace.id}
      workspaceName={workspace.name}
      postsCount={workspace.postsCount || 0}
      assetsCount={workspace.assetsCount || 0}
    />
  );
}
